'use client';
import Dialog from '@ui/Dialog';
import useNonProfitOnBoardDialogStore from '@/components/store/nonProfitOnBoardDialogSlice';
import React, { useState } from 'react';
import NonProfitOnBoardForm from './NonProfitOnBoardForm';
import Image from 'next/image';
import Typography from '@ui/Typography';

function NonProfitOnBoardDialog(props) {
  const isOpen = useNonProfitOnBoardDialogStore((state) => state.open);
  const nonProfit = useNonProfitOnBoardDialogStore((state) => state.nonProfit);
  const setIsOpen = useNonProfitOnBoardDialogStore((state) => state.setOpen);

  const [dialogStep, setDialogStep] = useState('');

  function closeModal() {
    setIsOpen(false);
  }

  function onSubmit(data) {
    const { avatar, country, ...rest } = data;
    // const formData = new FormData();
    // formData.append('data', JSON.stringify({ ...rest, country: country.id }));
    // if (avatar) {
    //   formData.append('avatar', avatar);
    // }

    // console.log('formData', formData);
    // console.log('FinalData', data);

    // const { errored } = await requestPost(
    //   `public/non-profits/${nonProfitId}/apply`,
    //   formData,
    //   MULTIPART_FORM_DATA_HEADER
    // );
    // if (!errored) {
    //   setDialogStep('success');
    // }

    closeModal();
  }

  return (
    <Dialog
      isOpen={isOpen}
      onClose={closeModal}
      maxWidth="lg"
      iconUrl={nonProfit ? nonProfit.logo_url : null}>
      <div className="flex p-6 lg:p-0 w-full gap-24">
        {dialogStep !== 'final' && (
          <div className="hidden lg:flex items-center">
            <Image
              width={333}
              height={303}
              src="/assets/images/onboard-dialog-bg.png"
              alt="background image"
              priority
            />
          </div>
        )}
        <div className="flex flex-col gap-12 flex-1">
          <NonProfitOnBoardForm
            nonProfitId={nonProfit?.id}
            onSubmit={onSubmit}
            setDialogStep={setDialogStep}
          />
        </div>

        {dialogStep === 'success' && (
          <div className="flex flex-col gap-12 flex-1 w-full">
            <Typography variant="h1" component="h2">Thank You!</Typography>
            <Typography variant="body2">
              Your request has been submitted and is pending approval. You will
              receive an email once your application has been approved.
            </Typography>
          </div>
        )}
      </div>
    </Dialog>
  );
}

export default NonProfitOnBoardDialog;
